export type MenuItemObjectType = {
	path: string;
	title: string;
};

export const MENU_ITEMS = [
	{
		organization: [
			{
				path: "/organization/general",
				title: "일반",
			},
			{
				path: "/organization/applications",
				title: "어플리케이션",
			},
			{
				path: "/organization/members",
				title: "멤버관리",
			},
			{
				// path: "/organization/billing/information",
				path: "/organization/billing/applicationList",
				title: "결제/청구",
			},
			{
				path: "/organization/contact",
				title: "문의하기",
			},
			{
				path: "/organization/contract",
				title: "표준계약서 확인",
			},
		],
		account: [
			{
				path: "/account/profile",
				title: "프로필",
			},
			{
				path: "/account/security",
				title: "보안설정",
			},
		],
	},
	{
		organization: [
			{
				path: "/organization/general",
				title: "General",
			},
			{
				path: "/organization/applications",
				title: "Application",
			},
			{
				path: "/organization/members",
				title: "Member Management",
			},
			{
				// path: "/organization/billing/information",
				path: "/organization/billing/applicationList",
				title: "Payment / Billing",
			},
			{
				path: "/organization/contact",
				title: "Contact Us",
			},
			{
				path: "/organization/contract",
				title: "Standard Confirmation Document",
			},
		],
		account: [
			{
				path: "/account/profile",
				title: "Profile",
			},
			{
				path: "/account/security",
				title: "Security Settings",
			},
		],
	},
];

/* export const MENU_ITEMS = {
	organization: [
		{
			path: "/organization/general",
			title: i18n.language === "en" ? "General" : "일반",
		},
		{
			path: "/organization/applications",
			title: "어플리케이션",
		},
		{
			path: "/organization/members",
			title: "멤버관리",
		},
		{
			// path: "/organization/billing/information",
			path: "/organization/billing/applicationList",
			title: "결제/청구",
		},
		{
			path: "/organization/contact",
			title: "문의하기",
		},
		{
			path: "/organization/contract",
			title: "표준계약서 확인",
		},
	],
	account: [
		{
			path: "/account/profile",
			title: "프로필",
		},
		{
			path: "/account/security",
			title: "보안설정",
		},
	],
}; */
